'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProjectRecipientsList.scss');

var ProjectRecipientsListGroupItem = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ProjectRecipientsListGroupItem, _PureComponent);

  function ProjectRecipientsListGroupItem() {
    (0, _classCallCheck3.default)(this, ProjectRecipientsListGroupItem);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectRecipientsListGroupItem.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientsListGroupItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectRecipientsListGroupItem, [{
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          onClick = _props.onClick,
          group = _props.group;

      onClick(group);
    }
  }, {
    key: 'deleteGroup',
    value: function deleteGroup(e) {
      (0, _utils.stopEvent)(e);
      var _props2 = this.props,
          group = _props2.group,
          onDelete = _props2.onDelete;

      onDelete(group);
    }
  }, {
    key: 'bindPopover',
    value: function bindPopover(el) {
      this.popover = el;
    }
  }, {
    key: 'togglePopover',
    value: function togglePopover(e) {
      this.popover.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          group = _props3.group,
          individualExpiryDate = _props3.individualExpiryDate,
          downloadAuthorised = _props3.downloadAuthorised,
          loading = _props3.loading;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(className, styles.recipientRow, styles.groupRow), onClick: this.onClick },
        _react2.default.createElement(
          'div',
          { className: styles.idColumn },
          _react2.default.createElement('i', { className: styles.groupIcon })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.nameColumn },
          group.groupName
        ),
        individualExpiryDate && _react2.default.createElement('div', { className: styles.dateColumn }),
        downloadAuthorised && _react2.default.createElement('div', { className: styles.authColumn }),
        _react2.default.createElement('div', { className: styles.statusColumn }),
        _react2.default.createElement(
          'div',
          { className: styles.actionsColumn },
          _react2.default.createElement(_Button2.default, {
            className: (0, _bind2.default)('btn-text', styles.deleteButton),
            onClick: this.deleteGroup,
            loading: loading,
            small: true
          })
        )
      );
    }
  }]);
  return ProjectRecipientsListGroupItem;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  downloadAuthorised: _propTypes2.default.bool,
  group: _propTypes2.default.object,
  individualExpiryDate: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onDelete: _propTypes2.default.func
}, _class2.defaultProps = {
  group: {},
  onClick: _noop3.default,
  onDelete: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteGroup'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bindPopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePopover'), _class.prototype)), _class);
exports.default = ProjectRecipientsListGroupItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/ProjectRecipientsList/ProjectRecipientsListGroupItem.js
// module id = 2088
// module chunks = 1